"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayProps = exports.addImageDefaultSrc = exports.staticAssetsUrl = exports.determineProductName = exports.getDisplayUom = void 0;

var frontend_common_1 = require("@ryerson/frontend.common");

var common_uom_1 = require("@ryerson/common.uom");

var getDisplayUom = function getDisplayUom(uomString) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "quantity";
  var makePlural = ["LB", "PC"].includes(uomString) && type === "quantity" ? true : false;
  uomString = makePlural ? "".concat(uomString, "S") : uomString;
  return common_uom_1.UOMDisplay[uomString] || uomString;
};

exports.getDisplayUom = getDisplayUom;

var determineProductName = function determineProductName(product) {
  var _a;

  var productDisplay = (0, frontend_common_1.determineProductDisplay)(product === null || product === void 0 ? void 0 : product.altPartNumber, product === null || product === void 0 ? void 0 : product.fastPath);

  if (productDisplay) {
    return "".concat(productDisplay.replace(/<br\/>/gi, ""), " ").concat((_a = product.description) === null || _a === void 0 ? void 0 : _a.replace(/<br\/>/gi, ""));
  }

  return "";
};

exports.determineProductName = determineProductName;
exports.staticAssetsUrl = "".concat(process.env.GATSBY_ENV_URL || "", "/static-assets/images/renderings/");

var addImageDefaultSrc = function addImageDefaultSrc(event) {
  event.target.src = "".concat(exports.staticAssetsUrl, "NoImageAvailable.png");
};

exports.addImageDefaultSrc = addImageDefaultSrc;

var getDisplayProps = function getDisplayProps(isMobile, isNative, theme) {
  var _theme$colors$primary = theme.colors.primary,
      white = _theme$colors$primary.white,
      lighterGray = _theme$colors$primary.lighterGray,
      darkGray = _theme$colors$primary.darkGray;
  var notificationProps = isMobile ? {
    bgColor: white,
    borderColor: lighterGray,
    isNative: isNative
  } : {
    bgColor: white,
    borderColor: lighterGray
  };
  var headerProps = isMobile ? {
    bgColor: darkGray
  } : {
    bgColor: lighterGray
  };
  var typeProps = isMobile ? {
    color: white,
    type: "tertiary",
    size: "xl"
  } : {
    type: "primary",
    size: "lg"
  };
  var buttonProps = {
    label: "",
    variant: isMobile ? "outline" : "solid",
    shape: "circle",
    type: "secondary",
    size: "xs",
    leftIcon: "close",
    background: isMobile ? white : ""
  };
  return {
    notificationProps: notificationProps,
    headerProps: headerProps,
    typeProps: typeProps,
    buttonProps: buttonProps
  };
};

exports.getDisplayProps = getDisplayProps;